import * as React from 'react';
import { IconButton, IconClose16, UIHeading2 } from '@cian/ui-kit';

import { InfoPlate } from '..';
import { TransportDepartmentIcon, TransportDepartmentInfo } from './parts';

import * as styles from './TransportAccessibilitySidebar.css';

export interface ITransportAccessibilitySidebarProps extends React.PropsWithChildren {
  onClose: () => void;
  tabs: React.ReactNode;
}

export const TransportAccessibilitySidebar: React.FC<ITransportAccessibilitySidebarProps> = ({
  children,
  onClose,
  tabs,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['close-button']}>
        <IconButton icon={<IconClose16 />} onClick={onClose} />
      </div>
      <div className={styles['header']}>
        <UIHeading2>Транспортная доступность</UIHeading2>
      </div>
      {tabs && (
        <div className={styles['tabs-wrapper']} data-testid="TransportAccessibilityTabs">
          {tabs}
        </div>
      )}
      <div className={styles['content-wrapper']}>
        {children}
        <div className={styles['data-from']}>
          <InfoPlate icon={<TransportDepartmentIcon />} content={<TransportDepartmentInfo />} withHorizontalMargin />
        </div>
      </div>
    </div>
  );
};
